// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-panel {
    margin-top: 1.5rem;
    background: #f2faff;
    border: 1px solid #b3d7ff;
    border-left: 5px solid #0061b0;
    padding: 1rem;
    border-radius: 8px;
}

.suggestion-card {
    padding: 0.75rem 1rem;
    background: #ffffff;
    margin-bottom: 1rem;
    border-left: 4px solid #0070c0;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

    .suggestion-card h4 {
        margin: 0 0 4px;
        font-size: 1rem;
        color: #0061b0;
    }

    .suggestion-card p {
        font-size: 0.9rem;
        margin-bottom: 6px;
    }

    .suggestion-card button {
        background: #0061b0;
        color: white;
        border: none;
        padding: 5px 12px;
        border-radius: 4px;
        cursor: pointer;
        margin-top: 6px;
    }

    .suggestion-card.high {
        border-left-color: #cc0000;
    }

    .suggestion-card.medium {
        border-left-color: #ff9800;
    }

    .suggestion-card.low {
        border-left-color: #00a86b;
    }
`, "",{"version":3,"sources":["webpack://./src/components/AI/AIAssistantPanel.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,sCAAsC;AAC1C;;IAEI;QACI,eAAe;QACf,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,YAAY;QACZ,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B","sourcesContent":[".ai-panel {\n    margin-top: 1.5rem;\n    background: #f2faff;\n    border: 1px solid #b3d7ff;\n    border-left: 5px solid #0061b0;\n    padding: 1rem;\n    border-radius: 8px;\n}\n\n.suggestion-card {\n    padding: 0.75rem 1rem;\n    background: #ffffff;\n    margin-bottom: 1rem;\n    border-left: 4px solid #0070c0;\n    border-radius: 6px;\n    box-shadow: 0 1px 2px rgba(0,0,0,0.05);\n}\n\n    .suggestion-card h4 {\n        margin: 0 0 4px;\n        font-size: 1rem;\n        color: #0061b0;\n    }\n\n    .suggestion-card p {\n        font-size: 0.9rem;\n        margin-bottom: 6px;\n    }\n\n    .suggestion-card button {\n        background: #0061b0;\n        color: white;\n        border: none;\n        padding: 5px 12px;\n        border-radius: 4px;\n        cursor: pointer;\n        margin-top: 6px;\n    }\n\n    .suggestion-card.high {\n        border-left-color: #cc0000;\n    }\n\n    .suggestion-card.medium {\n        border-left-color: #ff9800;\n    }\n\n    .suggestion-card.low {\n        border-left-color: #00a86b;\n    }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
